import React from 'react';

import styles from './CustomVideoControls.module.scss';

const PlayerControls = ({ onPlayPause, playing, playIcon, pauseIcon }) => {
  return (
    <div className={styles.controlsWrapper}>
      <div onClick={onPlayPause}>{playing ? pauseIcon() : playIcon()}</div>
    </div>
  );
};

export default PlayerControls;
